import React from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

// This object is used in the cardSupportedCurrenciesACDC_Focus_Columns array of the SearchableTableACDCNotCollapsed object to format content defined in the cardSupportedCurrenciesACDC_Focus_Rows array.
// CurrenciesCell takes an array of currencies and presents them in HTML format, in sequence, with commas.
// CurrenciesCell creates an array named cur that takes the currencies and footnotes passed into the object, and returns the number of currencies as i.
// CurrenciesCell adds line breaks after a number of currencies defined in shouldAddLineBreak.
// CurrenciesCell iterates through i each time an array value is passed, and returns a line break every time shouldAddLineBreak reaches a 7, in this example.
// The expected input for value is a 3-letter currency code value. CurrenciesCell formats the currency code passed by value as code.
// The expected input for footnote is 1 alphanumeric character. This value is optional.
// CurrenciesCell formats the optional footnote passed by footnote as superscript.
// CurrenciesCell adds a comma to every value except the last value in the array.
// If there was no footnote passed, CurrenciesCell returns the superscript formatting around a blank value.
// Note: CurrenciesCell doesn't sanitize the input, so the values could be anything.
// Note: CurrenciesCell doesn't check whether a footnote value was passed.

// Define the ICellType interface if not already defined or imported
interface ICellTypeItem {
  value: string
  footnote?: string
}
type ICellType = ICellTypeItem[]

const CurrenciesCell = ({ value }: { value: ICellType }) => {
  return (
    <>
      {value.map((cur: ICellTypeItem, i: number) => {
        const isLast = i === value.length - 1
        const shouldAddLineBreak = (i + 1) % 7 === 0 && !isLast
        return (
          <>
            <code>{cur.value}</code> <sup>{cur.footnote}</sup>
            {isLast ? null : ','}
            {shouldAddLineBreak ? <br /> : null}
          </>
        )
      })}
    </>
  )
}

export default CurrenciesCell
